import { render, staticRenderFns } from "./AwsComplianceBanner.vue?vue&type=template&id=d5d708ce&scoped=true&"
import script from "./AwsComplianceBanner.vue?vue&type=script&lang=js&"
export * from "./AwsComplianceBanner.vue?vue&type=script&lang=js&"
import style0 from "./AwsComplianceBanner.vue?vue&type=style&index=0&id=d5d708ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d708ce",
  null
  
)

export default component.exports